(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("widgets/emotionsratings", [], factory);
	else if(typeof exports === 'object')
		exports["widgets/emotionsratings"] = factory();
	else
		root["widgets/emotionsratings"] = factory();
})(self, () => {
return 